module.exports = __webpack_public_path__ + "img/copy-icon.455e3ee4.svg";